/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.bar {
  display: flex;
  flex-direction: row;
  position: fixed;
  left: 0px;
  right: 0px;
  background-color: var(--color-white, #fff);
  --tw-shadow: 0px 0px 6px var(--tw-shadow-color, rgba(0, 0, 0, 0.2));
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  height: 72px;
  padding-right: calc(var(--spacing, 0.25rem) * 6);
}
.status {
  display: flex;
  align-items: center;
  background-color: var(--color-gray-100, #f5f5f5);
  padding-inline: calc(var(--spacing, 0.25rem) * 7);
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
  color: var(--color-gray-600, #525252);
  flex-wrap: nowrap;
  white-space: nowrap;
}
.secondary-action-menu .action-bar-action .inner-content {
  --tw-font-weight: var(--font-weight-normal, 400);
  font-weight: var(--font-weight-normal, 400);
  color: var(--color-black, #000);
}
.secondary-action-menu .action-bar-action:hover {
  background-color: var(--color-gray-100, #f5f5f5);
  --tw-shadow: 0 0 0 2px var(--tw-shadow-color, var(--color-gray-500));
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-radius: var(--radius-sm, 0.25rem);
}
.actions {
  display: flex;
  padding-left: calc(var(--spacing, 0.25rem) * 4);
  gap: calc(var(--spacing, 0.25rem) * 2);
  min-width: 0px;
  flex: 1;
}
.actionsInner {
  display: flex;
  align-items: center;
  flex: 1;
  gap: calc(var(--spacing, 0.25rem) * 2);
  overflow: hidden;
  padding-left: var(--spacing, 0.25rem);
  max-width: 100%;
  min-width: 0px;
}
.secondaryActions {
  display: flex;
  align-items: center;
  padding-left: calc(var(--spacing, 0.25rem) * 6);
  min-width: 0px;
}
.divider {
  background-color: var(--color-gray-200, #e5e5e5);
  width: 1px;
  height: calc(var(--spacing, 0.25rem) * 10);
  margin-right: calc(var(--spacing, 0.25rem) * 4);
}
.action {
  display: flex;
  align-items: center;
  border-color: transparent;
  cursor: pointer;
  background-color: transparent;
  color: var(--color-primary-500);
  font-size: var(--text-sm, 0.875rem);
  line-height: var(--tw-leading, var(--text-sm--line-height, calc(1.25 / 0.875)));
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
  flex-wrap: nowrap;
  white-space: nowrap;
  padding: 0px;
  padding-right: calc(var(--spacing, 0.25rem) * 4);
  border-radius: var(--radius-xs, 0.125rem);
  height: calc(var(--spacing, 0.25rem) * 10);
}
.action:not([disabled]):hover {
  background-color: var(--color-gray-100, #f5f5f5);
  --tw-shadow: 0 0 0 2px var(--tw-shadow-color, var(--color-gray-500));
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-radius: var(--radius-sm, 0.25rem);
}
.actionIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(var(--spacing, 0.25rem) * 10);
  height: calc(var(--spacing, 0.25rem) * 10);
}
.disabled {
  opacity: 30%;
  cursor: default;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-font-weight: initial;
    }
  }
}
